import { LOCALES } from 'i18n/locales';

export const mapTabsIntl = {
    [LOCALES.ENGLISH]: {
        'mapTabs.notifications.title': 'Notifications',
        'mapTabs.layers.title': 'Layers',
        'mapTabs.legend.title': 'Legend',
        'mapTabs.enhancedMeasures.title': 'Enhanced measures',
        'mapTabs.enhancedMeasures.popover.1': 'Sites and assets covered by enhanced measures.',
        'mapTabs.enhancedMeasures.popover.2': 'Information on some assets may be limited for security reasons.',
        'mapTabs.enhancedMeasures.popover.3': 'Check supplementary data for safety critical and other information.',
        'mapTabs.isolatedViews.title': 'Isolated views',
        'mapTabs.isolatedViews.popover': 'Select an asset owner from the list below to only show their assets and features on the map.',
        'mapTabs.assetOwners.title': 'Asset owners',
        'mapTabs.assetOwners.popover.1': 'Organisations with assets in your area of interest: asset owners whose assets have been revealed within your drawn area.',
        'mapTabs.assetOwners.popover.2': 'Organisations who operate in the vicinity: asset owners who may not have assets in the area drawn, but operate in the vicinity.',
        'mapTabs.assetOwners.popover.3': 'Asset owners with different contact details for emergency situations will be included here.',
        'mapTabs.observations.title': 'Observations',
        'mapTabs.help.title': 'Help',
        'mapTabs.help.button.description': 'Open help page in new tab'
    },
    [LOCALES.WELSH]: {
        'mapTabs.notifications.title': 'Hysbysiadau',
        'mapTabs.layers.title': 'Haenau',
        'mapTabs.legend.title': 'Allwedd',
        'mapTabs.enhancedMeasures.title': '[Enhanced measures]',
        'mapTabs.enhancedMeasures.popover.1': 'Safleoedd ac asedau dan fesurau uwch.',
        'mapTabs.enhancedMeasures.popover.2': 'Gall gwybodaeth am rai asedau fod yn gyfyngedig am resymau diogelwch.',
        'mapTabs.enhancedMeasures.popover.3': 'Gwiriwch ddata atodol ar gyfer gwybodaeth hanfodol ynghylch diogelwch a gwybodaeth arall.',
        'mapTabs.isolatedViews.title': 'Golygon ynysig',
        'mapTabs.isolatedViews.popover': 'Dewiswch berchennog ased o\'r rhestr isod i ddangos dim ond eu hasedau a\'u nodweddion nhw ar y map.',
        'mapTabs.assetOwners.title': 'Perchnogion asedau',
        'mapTabs.assetOwners.popover.1': 'Sefydliadau sydd ag asedau yn eich ardal o ddiddordeb: perchnogion asedau y datgelwyd eu hasedau o fewn yr ardal rydych chi wedi\'i lluniadu.',
        'mapTabs.assetOwners.popover.2': 'Sefydliadau sy\'n gweithredu yn y cyffiniau: perchnogion asedau nad oes ganddynt asedau yn yr ardal wedi\'i lluniadu, ond sy\'n gweithredu yn y cyffiniau.',
        'mapTabs.assetOwners.popover.3': 'Bydd perchnogion asedau sydd â manylion cyswllt gwahanol ar gyfer sefyllfaoedd brys yn cael eu cynnwys yma.',
        'mapTabs.observations.title': 'Arsylwadau',
        'mapTabs.help.title': 'Help',
        'mapTabs.help.button.description': 'Agor y dudalen help mewn tab newydd'
    }
};
